import { useAtom, atom } from 'jotai';
import { useCallback } from 'react';

export const createModalState = () => {
  const modalAtom = atom(false);

  return () => {
    const [isOpen, setIsOpen] = useAtom(modalAtom);

    const open = useCallback(() => {
      setIsOpen(true);
    }, [setIsOpen]);

    const close = useCallback(() => {
      setIsOpen(false);
    }, [setIsOpen]);

    return {
      isOpen,
      open,
      close,
    };
  };
};
